// Shared lookup data for forms across the app.
export const COUNTRIES = [
  { code: "IN", name: "India", flag: "🇮🇳" },
  { code: "PK", name: "Pakistan", flag: "🇵🇰" },
  { code: "BD", name: "Bangladesh", flag: "🇧🇩" },
  { code: "CA", name: "Canada", flag: "🇨🇦" },
  { code: "US", name: "USA", flag: "🇺🇸" },
  { code: "UK", name: "United Kingdom", flag: "🇬🇧" },
  { code: "OT", name: "Other", flag: "🌍" },
];

export const countryFlag = (name) => {
  const c = COUNTRIES.find((x) => x.name === name);
  return c ? c.flag : "";
};

export const CURRENCIES = [
  { code: "inr", name: "Indian Rupee",      symbol: "₹"  },
  { code: "usd", name: "US Dollar",         symbol: "$"  },
  { code: "gbp", name: "British Pound",     symbol: "£"  },
  { code: "cad", name: "Canadian Dollar",   symbol: "C$" },
  { code: "pkr", name: "Pakistani Rupee",   symbol: "₨"  },
  { code: "bdt", name: "Bangladeshi Taka",  symbol: "৳"  },
];

export const INCOME_BRACKETS = {
  India:          ["Under ₹3L",     "₹3L–10L",     "₹10L–25L",     "₹25L–50L",     "₹50L–1Cr",       "₹1Cr+",       "Prefer not to say"],
  Pakistan:       ["Under ₨5L",     "₨5L–15L",     "₨15L–40L",     "₨40L–1Cr",     "₨1Cr+",          "Prefer not to say"],
  Bangladesh:     ["Under ৳5L",     "৳5L–15L",     "৳15L–40L",     "৳40L–1Cr",     "৳1Cr+",          "Prefer not to say"],
  Canada:         ["Under C$30k",   "C$30k–60k",   "C$60k–120k",   "C$120k–250k",  "C$250k+",        "Prefer not to say"],
  USA:            ["Under $25k",    "$25k–50k",    "$50k–100k",    "$100k–200k",   "$200k+",         "Prefer not to say"],
  "United Kingdom": ["Under £20k",  "£20k–40k",    "£40k–75k",     "£75k–150k",    "£150k+",         "Prefer not to say"],
  UK:             ["Under £20k",    "£20k–40k",    "£40k–75k",     "£75k–150k",    "£150k+",         "Prefer not to say"],
  Other:          ["Under $25k",    "$25k–50k",    "$50k–100k",    "$100k–200k",   "$200k+",         "Prefer not to say"],
};

export function incomeBracketsFor(country) {
  return INCOME_BRACKETS[country] || INCOME_BRACKETS.Other;
}
